module.exports = __webpack_public_path__ + "img/icon-speed.ba9b2d1e.svg";